const MEASUREMENT_UNIT_LABELS: Record<string, string> = {
    SQ: "Square",
    LF: "Linear Foot",
    COUNT: "Count",
    HOURS: "Hours",
    HR: "Hour",
    HRS: "Hours",
    EA: "Each",
    PC: "Piece",
    PCS: "Pieces",
};

export function formatMeasurementUnit(unit: string): string {
    const trimmed = unit?.trim();
    if (!trimmed) return unit;

    const key = trimmed.toUpperCase();
    return MEASUREMENT_UNIT_LABELS[key] ?? trimmed;
}
